import React from "react";

const AccountSetting = () => {

  return <div>AccountSetting</div>;
};

export default AccountSetting;
